import React from "react";
import RadioGroupGeneric from "../../../../../../components/Inputs/RadioGroupGeneric";
import { opOtrosBancos } from "../../../../../../propsType/Payemnts";
import { useState } from "react";
import ButtonGeneric from "../../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../../assets/png/bill.png";
import Bancos from "./Bancos";

const OtrosBancos = ({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) => {
  const [formSeleccione, setFormSeleccione] = useState({ banco: "" });
  const [errorSeleccion, setErrorSeleccion] = useState(null);
  const [seleccionBanco, setSeleccionBanco] = useState(false);
  const handleSeleccion = (e) => {
    setFormSeleccione({ ...formSeleccione, banco: e });
  };
  //Funcion que que guarda el banco seleccionado
  const elegir = () => {
    if (!formSeleccione.banco) {setErrorSeleccion(true);} 
    else {
      setErrorSeleccion(false);
      setSeleccionBanco(true);
      setData({ ...data, formSeleccione });
      setData({ ...data, title: "Otros Bancos" });
    }
  };
   //Funcion para volver al selector de bancos
  const atras = () => {
    setSeleccionBanco(false);
    setFormSeleccione({ ...formSeleccione, banco: "" });
  };
  return (
    <div>
      <>
        {seleccionBanco ? (
          <>
            <>
              {(formSeleccione?.banco?.title === "Bancaribe" ||
                formSeleccione?.banco?.title === "Bancrecer" ||
                formSeleccione?.banco?.title === "Banco del Tesoro" ||
                formSeleccione?.banco?.title === "Bancamiga" ||
                formSeleccione?.banco?.title === "R4 Banco Microfinanciero" ||
                formSeleccione?.banco?.title === "Banfanb") && (
                  <Bancos
                    data={data}
                    setData={setData}
                    stapsState={stapsState}
                    setStapsState={setStapsState}
                    back={atras}
                    deatils={deatils}
                    bankInfo={formSeleccione}
                  />
                )}
            </>
          </>
        ) : (
          <>
            <div className="flex lg:pt-[100px] pt-[190px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
              <div className="absolute left-0 top-0 w-full ">
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Pagar
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Selecciona el medio  por el cual deseas pagar
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-[70%]  ">
                <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                  <>
                    <div className="flex flex-col gap-6">
                      <>
                        <RadioGroupGeneric
                          numberCol={3}
                          sizeImg={true}
                          image={"yes"}
                          setValue={handleSeleccion}
                          array={opOtrosBancos}
                          error={errorSeleccion}
                        />
                      </>
                    </div>
                  </>
                  <div className="w-full flex justify-between gap-[50%]">
                    <div className="w-full">
                      <ButtonGeneric funtion={back} text={"Volver"} />
                    </div>
                    <div className="w-full">
                      <ButtonGeneric text={"Siguiente"} funtion={elegir} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-[30%] relative sha">
                <div
                  className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   before:content-[''] 
                    before:absolute 
                    before:w-[45px] 
                    before:h-[45px] 
                    before:rounded-full 
                    before:bg-white 
                    before:bottom-[-20px]
                    before:left-[-20px]
                   
                    after:content-[''] 
                    after:absolute 
                    after:w-[45px] 
                    after:h-[45px] 
                    after:rounded-full 
                    after:bg-white 
                    after:bottom-[-20px]
                    after:right-[-20px] "
                >
                  <div
                    className={` bg-[url("../public/bgCard.jpg")] bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-17%] z-[8] p-[2rem]`}
                  >
                    <div className="flex w-full justify-center absolute top-0  right-0  ">
                      <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
                    </div>
                    <div className="flex justify-center items-center">
                      <div className="w-[90%] object-contain">
                        <img
                          className="w-full object-contain "
                          src={formSeleccione?.banco?.logo}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="h-40% grid gap-[10px]">
                      <div className="font-medium text-center">
                        {data.metodoPago.title}{" "}
                      </div>
                      <div className="flex flex-col justify-between items-center">
                        <div className="font-medium text-center ">
                          {" "}
                          <div className="whitespace-nowrap">
                            Número de cuenta
                          </div>{" "}
                        </div>
                        <div className="text-center"> {deatils.nroCuenta} </div>
                      </div>
                      <div className="flex flex-col justify-between items-center">
                        <div className="font-medium w-full text-center">
                          Moneda
                        </div>
                        <div className=" w-full text-center">
                          {data?.data?.title}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-end w-full p-5 gap-4">
                    <div className="flex justify-between ">
                      <div className="text-[#798791] "> {
                        deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                          (
                            <>
                              Saldo a favor
                            </>
                          )
                          :
                          (
                            <>
                              Saldo
                            </>
                          )
                      }</div>{" "}
                      <div className="font-medium">
                        Bs {deatils?.deudaTotalVEF}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-center ">
                  <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
                </div>
                <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
                  <div className="w-full p-5 flex justify-between items-center">
                    <div>
                      <div className="text-[#798791] ">Monto a Pagar</div>
                      <div className="text-2xl font-medium">
                        <span className="text-[#798791] pr-2 ">Bs</span>
                        {data?.metodoAPagar}
                      </div>
                    </div>
                    <div className="w-[35px] ">
                      <img src={bills} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default OtrosBancos;
